// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "index" + "77d883c9e184bc87e430" + ".js";
};